import { type UseQueryResult, useQuery } from 'react-query';
import { SandboxOptionsService } from '../../services/wealthlane-identity-services';

const useGetSandboxOptionType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const sandboxOptionType = useQuery(
    ['getSandboxOptionType'],
    async () => {
      return await handleRequest(SandboxOptionsService.getApiIdentityApiSandboxOptionsType());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
            // isDisabled: item?.name === 'Copy' ? true : false,
          };
        });
      },
    }
  );

  return sandboxOptionType;
};

export default useGetSandboxOptionType;
